import { createSmartTaskReminder } from './getSmartTodosOrRemindersForItem.locstring.json';
import { ControlIcons } from 'owa-control-icons';
import loc from 'owa-localize';
import { lazyReplyByMeeting } from 'owa-mail-reading-pane-store';
import { FeatureNames } from 'owa-mail-smart-pill-features';
import { SmartTaskSuggestion } from 'owa-mail-store';
import { initializeSmartPillLogData, SmartPillData, SmartPillLogData } from 'owa-smart-pill';

export default function createSmartReminderPillData(
    smartReminder: SmartTaskSuggestion,
    itemId: string,
    internetMessageId: string,
    displayText: string,
    index: number
): SmartPillData {
    const logData: SmartPillLogData = initializeSmartPillLogData(
        FeatureNames.SmartReminder,
        displayText
    );
    logData.mainPayload.confidenceScore = smartReminder.confidenceScore;
    logData.mainPayload.EID = smartReminder.entityId;

    return {
        ariaLabel: loc(createSmartTaskReminder),
        featureName: FeatureNames.SmartReminder,
        icon: { iconName: ControlIcons.AddEvent },
        onClick: () => {
            lazyReplyByMeeting.importAndExecute(
                itemId /* reference item id */,
                null /*calendar view state - populate calendar form with smart suggested data */,
                false /*should send draft message boolean flag */,
                null /*source of the action (default) */,
                smartReminder.entityId /*extraction source id associated with this smart component */,
                internetMessageId,
                true /* send exclude attendees in the calendar event*/
            );
        },
        logData: logData,
        index: index,
        text: displayText,
        toolTip: displayText,
        confidenceScore: smartReminder.confidenceScore,
    };
}
